import { documentRouter } from './router'

export {
  documentRouter
}
